import { render, staticRenderFns } from "./AsEdit.vue?vue&type=template&id=3c5bdb14&"
import script from "./AsEdit.vue?vue&type=script&lang=js&"
export * from "./AsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports